module.exports = {
  "wrapper": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0
  },
  "dof-result": {
    "flex": 1,
    "alignItems": "center",
    "justifyContent": "center"
  },
  "result-image": {
    "width": "320",
    "height": "320"
  },
  "result-content": {
    "marginTop": "0",
    "alignItems": "center"
  },
  "content-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "28",
    "color": "#616c73",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "36",
    "width": "600"
  },
  "content-desc": {
    "marginTop": "8"
  },
  "result-button": {
    "marginTop": "48",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "btn-sub-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "28",
    "color": "#00a4f2",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "28",
    "marginTop": "32"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7d2d70f6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-result/index.vue
// module id = 525
// module chunks = 0 1